/** Entry point for the opt-in Word .docx import bundle. */
import { installDocxImport } from '@openleaf-editor/plugins-import-docx'

installDocxImport()
